import React from 'react';
import { motion } from 'framer-motion';
export function Reviews() {
  const reviews = [{
    text: "Absolutely the best pest control service we've ever used. They showed up on time, explained everything clearly, and we haven't seen a single ant since.",
    author: 'Michael T.',
    role: 'Homeowner',
    initials: 'MT'
  }, {
    text: 'Love supporting a local family business! They are so thorough and genuinely care about their customers. The scorpion problem we had is completely gone.',
    author: 'Sarah J.',
    role: 'Local Resident',
    initials: 'SJ'
  }, {
    text: "Professional, polite, and incredibly effective. I appreciate that they don't try to lock you into crazy long-term contracts. Highly recommend Ultimate Pest Co.",
    author: 'David R.',
    role: 'Business Owner',
    initials: 'DR'
  }];
  return <section id="reviews" className="bg-brand-black py-24 px-6" data-id="element-209">
      <div className="max-w-7xl mx-auto" data-id="element-210">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16 text-center flex flex-col items-center" data-id="element-211">
          <div className="flex items-center gap-4 mb-4" data-id="element-212">
            <div className="w-10 h-[2px] bg-brand-green" data-id="element-213" />
            <span className="font-condensed uppercase text-brand-green tracking-widest font-semibold" data-id="element-214">
              Reviews
            </span>
            <div className="w-10 h-[2px] bg-brand-green" data-id="element-215" />
          </div>
          <h2 className="text-4xl sm:text-5xl md:text-7xl text-white" data-id="element-216">
            WHAT OUR <span className="text-brand-green" data-id="element-217">CLIENTS</span> SAY
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-218">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-brand-card p-6 md:p-8 border border-white/5 hover:border-brand-green/50 transition-colors duration-300 relative flex flex-col h-full" data-id="element-219">
              {/* Large Quote Mark */}
              <div className="absolute top-4 right-6 text-8xl font-serif text-white/5 leading-none pointer-events-none" data-id="element-220">
                "
              </div>

              <div className="flex gap-1 mb-6 text-brand-green text-xl" data-id="element-221">
                ★★★★★
              </div>

              <p className="font-barlow italic text-brand-gray text-base md:text-lg leading-relaxed mb-6 md:mb-8 flex-grow relative z-10" data-id="element-222">
                "{review.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-223">
                <div className="w-12 h-12 rounded-full bg-brand-green flex items-center justify-center font-condensed font-bold text-black text-xl" data-id="element-224">
                  {review.initials}
                </div>
                <div data-id="element-225">
                  <h4 className="font-condensed uppercase text-white font-semibold tracking-wide text-lg" data-id="element-226">
                    {review.author}
                  </h4>
                  <p className="font-barlow text-brand-gray text-sm" data-id="element-227">
                    {review.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}